/**
 * 플랫폼 운영자와 지점 운영자의 기본 업무 화면을 분리한다.
 * master는 전체 운영 콘솔을, manager/staff/readonly는 자기 지점 점주 콘솔을 쓴다.
 */
export const isStoreOperatorRole = (role) =>
  ['manager', 'staff', 'readonly'].includes(role);

export const adminLandingPath = (role) =>
  isStoreOperatorRole(role) ? '/owner-v2' : '/';
